import {
  SET_TAG_LOADING,
  SET_TAG_OPTIONS,
  TagActionTypes,
  TagState,
} from "./types";

export const initialState: TagState = {
  instrumentTypeOptions: [],
  programVersionOptions: [],
  modelTagOptions: [],
  analysisTagOptions: [],
  allTagOptions: [],
  tagsLoading: false,
};

const reducer = (state = initialState, action: TagActionTypes) => {
  const stateCopy: TagState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case SET_TAG_OPTIONS: {
      return {
        ...stateCopy,
        instrumentTypeOptions: action.payload.instrumentTypeOptions,
        programVersionOptions: action.payload.programVersionOptions,
        modelTagOptions: action.payload.modelTagOptions,
        analysisTagOptions: action.payload.analysisTagOptions,
        allTagOptions: action.payload.allTagOptions,
      };
    }
    case SET_TAG_LOADING: {
      return {
        ...stateCopy,
        tagsLoading: action.payload,
      };
    }
    default:
      return stateCopy;
  }
};

export default reducer;
